import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/Layout/ScrollToTop';
import GlobalStyles from './styles/GlobalStyles';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import PrivacyDE from './pages/PrivacyDE';
import PrivacyEN from './pages/PrivacyEN';
import Imprint from './pages/Imprint';
import ImprintDE from './pages/ImprintDE';
import ImprintEN from './pages/ImprintEN';
import Terms from './pages/Terms';
import WorkSamples from './pages/WorkSamples';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Funding from './pages/Funding';
import { LanguageProvider } from './components/Layout/LanguageContext';
import { CookieConsentProvider } from './components/CookieConsent';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <GlobalStyles />
        <CookieConsentProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/privacy-de" element={<PrivacyDE />} />
              <Route path="/privacy-en" element={<PrivacyEN />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/imprint-de" element={<ImprintDE />} />
              <Route path="/imprint-en" element={<ImprintEN />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/samples" element={<WorkSamples />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/foerderung" element={<Funding />} />
            </Routes>
          </Layout>
        </CookieConsentProvider>
      </Router>
    </LanguageProvider>
  );
};

export default App;
